<template>
  <div>
    <common-dialog
      ref="dialog"
      width="300px"
      show-save-button
      unit="均量值计算设置"
      id-key="OtherId"
      :data="data"
      form-label-width="60px"
      :before-save="onBeforeSave"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="等级" prop="MeanValueName">
              <el-select size="mini" v-model="data.MeanValueName" style="width:100%;">
                <el-option v-for="item in lvList" :key="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="比例" prop="StartValue">
              <el-input v-model="data.StartValue" type="number" style="width:46%" placeholder="比例"></el-input>
              -
              <el-input v-model="data.EndValue" type="number" :style="isMB?'width:47.5%':'width:46%'" placeholder="比例"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赋值" prop="AssignValue">
              <el-input v-model="data.AssignValue" type="number" placeholder="请填写赋值"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import api from "@/api/achieve/params/average";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        MeanValueId: 0,
        MeanValueName: "",
        StartValue: null,
        EndValue: null,
        AssignValue: null,
      },
      lvList: ['A','B','C','D','E','F','G'],
      api,
      rules: {
        MeanValueName: [{ required: true, message: "请选择等级" }],
        StartValue: [{ required: true, message: "请填写比例" }],
        AssignValue: [{ required: true, message: "请填写赋值" }],
      },
      isMB: this.$store.state.isMB
    };
  },
  computed: {},
  methods: {
    onEditOpened() {
    },
    onCreateOpened() {
    },
    onBeforeSave() {
      if(!(this.data.StartValue>=0&&this.data.StartValue%1==0)) {
        this.$message.error("比例数值须为正整数")
        return false
      }
      if(this.data.StartValue>100||this.data.EndValue>100) {
        this.$message.error("比例数值不能超过100")
        return false
      }
      // if(!(this.data.EndValue>this.data.StartValue)) {
      //   this.$message.error("比例上限须大于下限")
      //   return false
      // }
      if(!(this.data.EndValue%1==0)) {
        this.$message.error("比例数值须为正整数")
        return false
      }
      // if(!(this.data.AssignValue>0&&this.data.AssignValue%1==0)) {
      //   this.$message.error("赋值须为正整数")
      //   return false
      // }
      return true
    },
  },
};
</script>
<style lang="scss">
</style>